import type { BeneficialOwnerResponse } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { DISPENSARY_BENEFICIAL_OWNERS_KEY } from 'tanstack-hooks/keys';

export function useCrbUpdateBeneficialOwnerArchiveStatus(dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();
  const queryClient = useQueryClient();

  const { mutate: updateBeneficialOwnerArchiveStatus, isPending: isUpdatingBeneficialOwnerArchiveStatus } =
    useMutation({
      mutationKey: [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
      mutationFn: ({
        beneficialOwnerId,
        archived,
        questionnaireBankId
      }: {
        beneficialOwnerId: string;
        archived: boolean;
        questionnaireBankId?: string;
      }) =>
        beneficialOwnerApi.crbUpdateBeneficialOwnerArchiveStatus(
          dispensaryId,
          beneficialOwnerId,
          archived,
          questionnaireBankId
        ),
      onSuccess: (updatedOwner) => {
        return queryClient.setQueryData(
          [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
          (old: BeneficialOwnerResponse[] | undefined) =>
            old?.map((owner) => (owner.id === updatedOwner.id ? updatedOwner : owner))
        );
      },
      meta: {
        snackbarSuccessMessage: 'Beneficial owner archive status updated successfully.',
        snackbarErrorMessage: 'There was an issue updating beneficial owner archive status.'
      }
    });

  return { updateBeneficialOwnerArchiveStatus, isUpdatingBeneficialOwnerArchiveStatus };
}
